import { ChevronDownIcon } from '@heroicons/react/20/solid';

/**
 * A select styled like a pill but with a visible border + chevron
 * so it's obvious it can be interacted with.
 *
 * `pillClass` provides bg/text/border tailwind classes for the current value.
 */
export default function PillSelect({ value, onChange, options, pillClass = '', className = '', disabled = false }) {
  return (
    <div className={`relative inline-block ${className}`}>
      <select
        value={value}
        onChange={onChange}
        disabled={disabled}
        className={`pl-2 pr-6 py-0.5 text-xs font-medium rounded-sm border cursor-pointer focus:outline-none focus:ring-1 focus:ring-slate-400 disabled:cursor-not-allowed disabled:opacity-60 ${pillClass}`}
        style={{ appearance: 'none', WebkitAppearance: 'none', backgroundImage: 'none' }}
      >
        {options.map((o) => (
          <option key={o.value} value={o.value} disabled={o.disabled}>
            {o.label}
          </option>
        ))}
      </select>
      <ChevronDownIcon className="w-3 h-3 absolute right-1.5 top-1/2 -translate-y-1/2 pointer-events-none opacity-70" />
    </div>
  );
}
